AJAXRPC = require './ajax-rpc'
Auth = require 'db/auth'
Backbone = require 'backbone'
Promise = require 'bluebird'
Socket = require 'network/socket'
SocketRPC = require './socket-rpc'
Storage = require 'lib/storage'
Util = require 'lib/util'
_ = require 'underscore'
log = require 'debug/log'
track = require 'debug/track'

window.dropTheHammer = ->
  Storage.set('useWebsockets', 'yes')
  console?.log?("Websockets engaged! Reload the page, please. Use pitStop() to turn sockets off.")

window.pitStop = ->
  Storage.set('useWebsockets', 'no')
  console?.log?("Shutting Websockets down! Reload the page, please. Use dropTheHammer() to turn sockets back on.")

# We want to immediately open up an rpc channel, so we use AJAX until the socket has connected
# and proven that it can answer a ping. If the socket connects and answers quickly, we use
# that for all future requests. If not, we just close it down and keep using AJAX. We defer
# setting up anything that will require polling on the AJAX rpc until we either confirm or
# give up on the socket rpc.
class RPC
  _.extend @prototype, Backbone.Events

  constructor: ->
    @rpcSocket = @rpcAJAX = @rpcCurrent = null
    @currentSubscriptions = {}

    @rpcConnectTime = 0
    @socketRetryWaitTime = 0

    # Always start an RPC if we're logged in, so we can get our notifications
    @handleLogin()

    return

  rpcReady: ->
    if !@isUsingSocket()
      @rpcCurrent.poll()

    @trigger('ready')

    @resubscribe()

    @listenTo @, 'reconnect', =>
      @resubscribe()

  resubscribe: ->
    @rpcCurrent.resync()

    for idModel, subscription of @currentSubscriptions
      @subscribe(subscription.modelType, idModel, subscription.tags)

  setActiveRPC: (rpc) ->
    @stopListening @rpcCurrent
    @rpcCurrent = rpc
    @listenTo @rpcCurrent, 'all', (args...) =>
      @trigger(args...)
    return

  lazyCreateRPC: ->
    if @isUsingSocket() || ((Util.getTime() - @rpcConnectTime) < @socketRetryWaitTime)
      return

    @rpcConnectTime = Util.getTime()
    @socketRetryWaitTime = Util.randomWait(Util.getMs(minutes: 20), Util.getMs(minutes: 10))

    # Create a new socket instance to force new Socket creation
    @rpcSocket = new SocketRPC(@)
    if @rpcAJAX?
      @rpcAJAX.stopPolling()
    else
      @rpcAJAX = new AJAXRPC(@)

    # Until the socket proves it works, you're on AJAX rpc.
    @setActiveRPC(@rpcAJAX)

    if (@rpcSocket.hasSocketTransport())
      # Sockets have a chance of working. They have 8s to answer a ping before we give up on 'em.
      msPingWait = 8000

      @rpcSocket.ping (err, result) =>
        pingElapsedTime = Util.getTime() - @rpcConnectTime
        if err? || pingElapsedTime > msPingWait
          # Socket took too long. Use AJAX.
          log('rpc', "Socket not responsive. Using AJAX.")
          @rpcSocket.disconnect()
          @rpcSocket.destroy()
          @rpcSocket = null
          @rpcReady()
          track("RPC", "No Sockets", "Slow ping", pingElapsedTime)
          setTimeout =>
            @lazyCreateRPC()
          , @socketRetryWaitTime
        else
          # Yay, we have sockets!
          log('rpc', "Socket responded to ping in a timely fashion. Using sockets.")
          @setActiveRPC(@rpcSocket)
          @rpcReady()
        return
    else
      # We do not have an acceptable socket transport. Use AJAX.
      log('rpc', "No socket connect. Using AJAX.")
      @rpcReady()

  handleLogin: ->
    if Auth.isLoggedIn()
      @lazyCreateRPC()

  unsubscribe: (modelType, idModel) ->
    @lazyCreateRPC()
    @rpcCurrent.unsubscribe(modelType, idModel)
    delete @currentSubscriptions[idModel]

  _subscribeOrHandle: (modelType, idModel, tags) ->
    Promise.fromNode (next) =>
      @rpcCurrent.subscribe(modelType, idModel, tags, next)
    .catch (err) =>
      if err.message == 'unauthorized'
        @unsubscribe(modelType, idModel)
        @trigger('subscription_unauthorized', modelType, idModel, tags)

  subscribe: (modelType, idModel, tags) ->
    @lazyCreateRPC()

    if (subscription = @currentSubscriptions[idModel])?
      subscription.tags = _.union(subscription.tags, tags)
    else
      @currentSubscriptions[idModel] =
        tags: tags
        ixLastUpdate: -1
        modelType: modelType
        idModel: idModel

    @_subscribeOrHandle(modelType, idModel, tags)

  getIxLastUpdate: (idModel) ->
    return @currentSubscriptions[idModel]?.ixLastUpdate

  setIxLastUpdate: (idModel, ixLastUpdate) ->
    @currentSubscriptions[idModel]?.ixLastUpdate = ixLastUpdate

  resync: (idModels...) ->
    @lazyCreateRPC()
    @rpcCurrent.resync?(idModels...)

  isUsingSocket: -> @rpcCurrent? && @rpcCurrent == @rpcSocket

module.exports = window.rpc = new RPC()



// WEBPACK FOOTER //
// ./app/scripts/network/rpc/index.coffee